import { Component, OnInit } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { FtpServer } from '../../../Model/FtpServer';
import { CatalogService } from '../../../Services/CatalogManagement/catalog.service';
import { FtpServerService } from '../../../Services/ftp/ftpServer.service';
import { UserManagementService } from '../../../Services/userManagment.service';
import { ForesightConnection } from '../../../Model/Catalog/ForesightConnection';
import { Catalog } from '../../../Model/Catalog/Catalog';

@Component({
    selector: 'foresightConnection',
    templateUrl: 'foresightConnection.component.html',
    styleUrls: [],
    standalone: false
})
export class ForesightConnectionComponent implements OnInit {
  ftpServers: FtpServer[] = [];

  constructor(private catalogService: CatalogService, private userManagement: UserManagementService, private ftpServerService: FtpServerService) { }

  async ngOnInit() {
    this.ftpServers = await lastValueFrom(this.ftpServerService.getAllServer());
  }

  get model(): ForesightConnection {
    const catalog = this.catalogService.catalog;
    if (!catalog.foresightConnection) {
      catalog.foresightConnection = new ForesightConnection();
      catalog.foresightConnection.articleFolder = '/pim/nextpim/';
      catalog.foresightConnection.manufacturerFolder = '/additional/';
      catalog.foresightConnection.exportFileName ="Golden_Record_Export"
    }
    return catalog.foresightConnection;
  }

  valueChanged(e) {
    this.catalogService.catalogChanged(e);
  }

  readOnlyUser(name: string, catalog: Catalog = this.catalogService.catalog): boolean {
    return !this.userManagement.canEdit(name, catalog);
  }
}
